// extracted by mini-css-extract-plugin
export default {"link":"FormFooterLinkButton_link__rjdHN","hoverUnderline":"FormFooterLinkButton_hoverUnderline__YGwEf"};